import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='m12.06 18.789 2.628-2.614-2.629-2.613-.838.838 1.229 1.229a5 5 0 0 1-1.713-.25 3.34 3.34 0 0 1-1.318-.798 3.6 3.6 0 0 1-.8-1.208 3.6 3.6 0 0 1-.273-1.357q0-.426.103-.85.103-.426.293-.816l-.888-.85a4.5 4.5 0 0 0-.529 1.21 4.829 4.829 0 0 0 .19 3.107q.36.897 1.061 1.602t1.702 1.054a6.5 6.5 0 0 0 2.057.364L11.22 17.95zm4.096-4.289q.357-.577.529-1.21.17-.635.17-1.29a5 5 0 0 0-.352-1.826 4.6 4.6 0 0 0-1.059-1.608 4.3 4.3 0 0 0-1.707-1.047 6.4 6.4 0 0 0-2.062-.34l1.114-1.129-.839-.838-2.629 2.613 2.629 2.613.839-.838-1.245-1.244q.915 0 1.721.272.806.271 1.328.795.522.523.797 1.202.274.68.274 1.36 0 .424-.104.85a4 4 0 0 1-.293.815zm-4.154 7a9.3 9.3 0 0 1-3.706-.748 9.6 9.6 0 0 1-3.016-2.03 9.6 9.6 0 0 1-2.032-3.016 9.25 9.25 0 0 1-.748-3.704q0-1.972.748-3.706a9.6 9.6 0 0 1 2.03-3.016 9.6 9.6 0 0 1 3.016-2.032 9.25 9.25 0 0 1 3.704-.748q1.972 0 3.706.748a9.6 9.6 0 0 1 3.017 2.03 9.6 9.6 0 0 1 2.03 3.016 9.25 9.25 0 0 1 .749 3.704q0 1.972-.748 3.706a9.6 9.6 0 0 1-2.03 3.017 9.6 9.6 0 0 1-3.016 2.03 9.25 9.25 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20'
    />
  </svg>
)
export default SvgComponent
